module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "oy"
    }
  }, [_c('h2', [_vm._v("Oy!")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "7%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "90%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("M= man W =wo man")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("Did you take out the trash?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("M:")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("I took out the trash.")]), _vm._v("\nDid you do the vash?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("I did the vash.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("Did you do my shirts?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("If I did the vash, I did your shirts.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("You didn’t mix the shirts with the regular stuff?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("No, I didn’t mix the shirts with the other stuff.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("You know what happens…")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("W:")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Never mind that.")]), _vm._v("\nDid you go to Schnitz’s Bakery to get the blintzes?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("M:")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("No, I didn’t go to get the blintzes.")]), _vm._v("\nWhen did you supposedly tell me?")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("Vhen you vuz soaking your feet.")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("No vonder I forgot!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd51864a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0006.vue
// module id = 87
// module chunks = 0